import { render, staticRenderFns } from "./check-apply.vue?vue&type=template&id=0736e4c9&scoped=true"
import script from "./check-apply.vue?vue&type=script&lang=ts"
export * from "./check-apply.vue?vue&type=script&lang=ts"
import style0 from "./check-apply.vue?vue&type=style&index=0&id=0736e4c9&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0736e4c9",
  null
  
)

export default component.exports